class ProductLightbox {
    constructor() {
        this.lightbox = null;
        this.currentImage = null;
        this.images = [];
        this.currentIndex = 0;
        this.zoomLevel = 1;
        this.isPanning = false;
        this.startX = 0;
        this.startY = 0;
        this.translateX = 0;
        this.translateY = 0;
        this.bgColor = '#FFFFFF';
        this.closeColor = '#000000';
        this.productHandle = '';
        this.init();
    }

    init() {
        const desktopTriggers = document.querySelectorAll('.lightbox-trigger');
        const mobileTriggers = document.querySelectorAll('.lightbox-trigger-mobile');
        const triggers = [...desktopTriggers, ...mobileTriggers];
        
        if (triggers.length === 0) {
            return;
        }
        
        // Aggiungi cursore personalizzato per i trigger desktop
        this.setupCustomCursor();

        let container = document.querySelector('.media-grid');
        if (!container) {
            container = document.querySelector('.lightbox-enabled-mobile');
        }
        
        if (container) {
            this.bgColor = container.dataset.lightboxBgColor || '#FFFFFF';
            this.closeColor = container.dataset.lightboxCloseColor || '#000000';
            this.productHandle = container.dataset.productHandle || '';
        }

        const uniqueImages = new Map();
        triggers.forEach((trigger) => {
            const mediaId = trigger.dataset.mediaId;
            if (!uniqueImages.has(mediaId)) {
                uniqueImages.set(mediaId, {
                    src: trigger.href,
                    mediaId: mediaId,
                    element: trigger
                });
            }
        });
        
        this.images = Array.from(uniqueImages.values());

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const mediaId = trigger.dataset.mediaId;
                const index = this.images.findIndex(img => img.mediaId === mediaId);
                
                if (index !== -1) {
                    this.open(index);
                }
                return false;
            });
        });

        this.createLightbox();
        document.addEventListener('keydown', this.handleKeyboard.bind(this));
        window.addEventListener('variant:changed', this.handleVariantChange.bind(this));
    }

    createLightbox() {
        this.lightbox = document.createElement('div');
        this.lightbox.className = 'product-lightbox-popup';
        this.lightbox.innerHTML = `
            <div class="lightbox-overlay"></div>
            <div class="lightbox-modal">
                <button class="lightbox-close" aria-label="Close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
                <div class="lightbox-main-container">
                    <div class="lightbox-controls-bar">
                        <button class="lightbox-nav-prev" aria-label="Previous image">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </button>
                        <div class="lightbox-zoom-controls">
                            <button class="zoom-out" aria-label="Zoom out">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <path d="m21 21-4.35-4.35"></path>
                                    <line x1="8" y1="11" x2="14" y2="11"></line>
                                </svg>
                            </button>
                            <span class="zoom-level">100%</span>
                            <button class="zoom-in" aria-label="Zoom in">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <path d="m21 21-4.35-4.35"></path>
                                    <line x1="11" y1="8" x2="11" y2="14"></line>
                                    <line x1="8" y1="11" x2="14" y2="11"></line>
                                </svg>
                            </button>
                            <button class="zoom-reset" aria-label="Reset zoom">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <polyline points="1 4 1 10 7 10"></polyline>
                                    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
                                </svg>
                            </button>
                        </div>
                        <button class="lightbox-nav-next" aria-label="Next image">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                    </div>
                    <div class="lightbox-images-scroll">
                    </div>
                </div>
                <div class="lightbox-thumbnails">
                </div>
                <div class="lightbox-counter">
                    <span class="current-index">1</span> / <span class="total-count">${this.images.length}</span>
                </div>
            </div>
        `;

        this.lightbox.style.display = 'none';
        document.body.appendChild(this.lightbox);
        
        this.applyCustomColors();
        this.populateImages();

        this.lightbox.querySelector('.lightbox-overlay').addEventListener('click', () => this.close());
        this.lightbox.querySelector('.lightbox-close').addEventListener('click', () => this.close());
        
        this.lightbox.querySelector('.lightbox-nav-prev').addEventListener('click', () => {
            this.goToImage((this.currentIndex - 1 + this.images.length) % this.images.length);
        });
        this.lightbox.querySelector('.lightbox-nav-next').addEventListener('click', () => {
            this.goToImage((this.currentIndex + 1) % this.images.length);
        });

        this.setupScrollAndZoom();
    }

    populateImages() {
        const scrollContainer = this.lightbox.querySelector('.lightbox-images-scroll');
        const thumbContainer = this.lightbox.querySelector('.lightbox-thumbnails');

        this.images.forEach((image, index) => {
            const imgWrapper = document.createElement('div');
            imgWrapper.className = 'lightbox-image-wrapper';
            imgWrapper.innerHTML = `
                <div class="lightbox-image-zoom-container" data-index="${index}">
                    <img src="${image.src}" alt="Product image ${index + 1}" class="lightbox-image">
                </div>
            `;
            scrollContainer.appendChild(imgWrapper);

            const thumb = document.createElement('div');
            thumb.className = 'lightbox-thumbnail';
            thumb.dataset.index = index;
            thumb.innerHTML = `<img src="${image.src}" alt="Thumbnail ${index + 1}">`;
            thumb.addEventListener('click', () => this.goToImage(index));
            thumbContainer.appendChild(thumb);
        });
    }

    setupScrollAndZoom() {
        const scrollContainer = this.lightbox.querySelector('.lightbox-images-scroll');
        
        scrollContainer.addEventListener('scroll', () => {
            const scrollLeft = scrollContainer.scrollLeft;
            const itemWidth = scrollContainer.offsetWidth;
            const newIndex = Math.round(scrollLeft / itemWidth);
            
            if (newIndex !== this.currentIndex) {
                this.currentIndex = newIndex;
                this.updateActiveStates();
                this.resetZoom();
            }
        });

        this.setupZoomControls();

        const imageContainers = this.lightbox.querySelectorAll('.lightbox-image-zoom-container');
        imageContainers.forEach((container) => {
            const img = container.querySelector('.lightbox-image');
            
            container.zoomState = {
                scale: 1,
                translateX: 0,
                translateY: 0,
                panning: false,
                start: { x: 0, y: 0 }
            };

            container.addEventListener('dblclick', (e) => {
                e.preventDefault();
                const state = container.zoomState;
                
                if (state.scale === 1) {
                    state.scale = 2.5;
                    
                    const rect = container.getBoundingClientRect();
                    const clickX = (e.clientX - rect.left) / rect.width - 0.5;
                    const clickY = (e.clientY - rect.top) / rect.height - 0.5;
                    
                    state.translateX = -clickX * rect.width * (state.scale - 1) / 2;
                    state.translateY = -clickY * rect.height * (state.scale - 1) / 2;
                } else {
                    state.scale = 1;
                    state.translateX = 0;
                    state.translateY = 0;
                }
                
                this.applyZoom(img, state);
                this.updateZoomLevel(state.scale);
            });

            container.addEventListener('wheel', (e) => {
                e.preventDefault();
                const state = container.zoomState;

                // Se lo zoom è attivo (scale > 1), usa la rotella per il panning
                if (state.scale > 1 && !e.ctrlKey) {
                    // Panning con rotella
                    const panSpeed = 2;

                    // Calcola il nuovo translate
                    const newX = state.translateX - (e.deltaX * panSpeed) - (e.shiftKey ? e.deltaY * panSpeed : 0);
                    const newY = state.translateY - (e.shiftKey ? 0 : e.deltaY * panSpeed);

                    // Con sistema di coordinate centrato, limiti simmetrici attorno a 0
                    const containerWidth = container.offsetWidth;
                    const containerHeight = container.offsetHeight;
                    const imgWidth = img.offsetWidth;
                    const imgHeight = img.offsetHeight;

                    const scaledWidth = imgWidth * state.scale;
                    const scaledHeight = imgHeight * state.scale;

                    // Calcola quanto l'immagine scalata eccede il container
                    const overflowX = Math.max(0, (scaledWidth - containerWidth) / 2);
                    const overflowY = Math.max(0, (scaledHeight - containerHeight) / 2);

                    // I limiti sono simmetrici: da -overflow a +overflow
                    state.translateX = Math.max(-overflowX, Math.min(overflowX, newX));
                    state.translateY = Math.max(-overflowY, Math.min(overflowY, newY));

                    img.style.transition = 'none';
                    this.applyZoom(img, state);
                } else {
                    // Zoom con rotella (quando scale = 1 oppure Ctrl+wheel)
                    const delta = e.deltaY > 0 ? 0.9 : 1.1;
                    const newScale = Math.min(Math.max(0.5, state.scale * delta), 5);

                    if (newScale !== state.scale) {
                        if (newScale <= 1) {
                            // Sotto o al 100%, centra l'immagine
                            state.scale = newScale;
                            state.translateX = 0;
                            state.translateY = 0;
                        } else {
                            const scaleFactor = newScale / state.scale;
                            state.scale = newScale;
                            state.translateX *= scaleFactor;
                            state.translateY *= scaleFactor;
                        }

                        this.applyZoom(img, state);
                        this.updateZoomLevel(state.scale);
                    }
                }
            }, { passive: false });

            img.addEventListener('mousedown', (e) => {
                const state = container.zoomState;
                e.preventDefault();
                state.panning = true;
                state.start = { 
                    x: e.clientX - state.translateX, 
                    y: e.clientY - state.translateY 
                };
                img.style.cursor = 'grabbing';
                img.style.transition = 'none';
            });

            img.addEventListener('mousemove', (e) => {
                const state = container.zoomState;
                if (state.panning) {
                    e.preventDefault();
                    
                    const newX = e.clientX - state.start.x;
                    const newY = e.clientY - state.start.y;
                    
                    const isMobile = window.innerWidth <= 768;
                    
                    if (isMobile) {
                        // Su mobile, calcola i limiti considerando object-fit: contain
                        const containerWidth = container.offsetWidth;
                        const containerHeight = container.offsetHeight;
                        
                        // Per mobile con object-fit: contain, l'immagine è sempre 100% del container
                        // quindi calcoliamo i limiti basati sullo scale
                        const scaledSize = state.scale * 100; // percentuale
                        const maxMove = (scaledSize - 100) / 2; // massimo movimento in percentuale
                        
                        // Converti i pixel in percentuale per il movimento
                        const percentX = (newX / containerWidth) * 100;
                        const percentY = (newY / containerHeight) * 100;
                        
                        // Limita il movimento per evitare spazi bianchi
                        state.translateX = Math.max(-maxMove * containerWidth / 100, 
                                                   Math.min(maxMove * containerWidth / 100, newX));
                        state.translateY = Math.max(-maxMove * containerHeight / 100, 
                                                   Math.min(maxMove * containerHeight / 100, newY));
                    } else {
                        // Desktop: con sistema di coordinate centrato
                        // translateX/Y = 0 significa immagine centrata
                        // I limiti sono simmetrici attorno a 0
                        const containerWidth = container.offsetWidth;
                        const containerHeight = container.offsetHeight;
                        const imgWidth = img.offsetWidth;
                        const imgHeight = img.offsetHeight;

                        const scaledWidth = imgWidth * state.scale;
                        const scaledHeight = imgHeight * state.scale;

                        // Calcola quanto l'immagine scalata eccede il container
                        const overflowX = Math.max(0, (scaledWidth - containerWidth) / 2);
                        const overflowY = Math.max(0, (scaledHeight - containerHeight) / 2);

                        // I limiti sono simmetrici: da -overflow a +overflow
                        state.translateX = Math.max(-overflowX, Math.min(overflowX, newX));
                        state.translateY = Math.max(-overflowY, Math.min(overflowY, newY));
                    }
                    
                    this.applyZoom(img, state);
                }
            });

            img.addEventListener('mouseup', () => {
                const state = container.zoomState;
                state.panning = false;
                img.style.cursor = 'grab';
                img.style.transition = 'transform 0.3s ease';
            });

            img.addEventListener('mouseleave', () => {
                const state = container.zoomState;
                state.panning = false;
                img.style.cursor = 'grab';
                img.style.transition = 'transform 0.3s ease';
            });

            let initialDistance = 0;
            let touchStartX = 0;
            let touchStartY = 0;

            container.addEventListener('touchstart', (e) => {
                const state = container.zoomState;
                
                if (e.touches.length === 2) {
                    e.preventDefault();
                    initialDistance = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY
                    );
                } else if (e.touches.length === 1) {
                    // Permetti panning su mobile anche con scale = 1
                    touchStartX = e.touches[0].clientX - state.translateX;
                    touchStartY = e.touches[0].clientY - state.translateY;
                    state.panning = true;
                }
            }, { passive: false });

            container.addEventListener('touchmove', (e) => {
                const state = container.zoomState;
                
                if (e.touches.length === 2) {
                    e.preventDefault();
                    const currentDistance = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY
                    );
                    
                    const newScale = Math.min(Math.max(0.5, state.scale * (currentDistance / initialDistance)), 5);
                    
                    if (newScale !== state.scale) {
                        state.scale = newScale;
                        // Sotto o al 100%, centra l'immagine
                        if (state.scale <= 1) {
                            state.translateX = 0;
                            state.translateY = 0;
                        }
                        this.applyZoom(img, state);
                        this.updateZoomLevel(state.scale);
                    }
                    
                    initialDistance = currentDistance;
                } else if (e.touches.length === 1 && state.panning) {
                    e.preventDefault();
                    
                    const newX = e.touches[0].clientX - touchStartX;
                    const newY = e.touches[0].clientY - touchStartY;
                    
                    const isMobile = window.innerWidth <= 768;
                    
                    if (isMobile && state.scale >= 1) {
                        const containerWidth = container.offsetWidth;
                        const containerHeight = container.offsetHeight;
                        
                        const scaledSize = state.scale * 100;
                        const maxMove = (scaledSize - 100) / 2;
                        
                        state.translateX = Math.max(-maxMove * containerWidth / 100, 
                                                   Math.min(maxMove * containerWidth / 100, newX));
                        state.translateY = Math.max(-maxMove * containerHeight / 100, 
                                                   Math.min(maxMove * containerHeight / 100, newY));
                    } else if (!isMobile && state.scale > 1) {
                        // Con sistema di coordinate centrato, limiti simmetrici attorno a 0
                        const containerWidth = container.offsetWidth;
                        const containerHeight = container.offsetHeight;
                        const imgElem = container.querySelector('.lightbox-image');
                        const imgWidth = imgElem.offsetWidth;
                        const imgHeight = imgElem.offsetHeight;

                        const scaledWidth = imgWidth * state.scale;
                        const scaledHeight = imgHeight * state.scale;

                        const overflowX = Math.max(0, (scaledWidth - containerWidth) / 2);
                        const overflowY = Math.max(0, (scaledHeight - containerHeight) / 2);

                        state.translateX = Math.max(-overflowX, Math.min(overflowX, newX));
                        state.translateY = Math.max(-overflowY, Math.min(overflowY, newY));
                    }
                    
                    img.style.transition = 'none';
                    this.applyZoom(img, state);
                }
            }, { passive: false });
            
            container.addEventListener('touchend', () => {
                const state = container.zoomState;
                state.panning = false;
                img.style.transition = 'transform 0.3s ease';
            });
        });
    }

    open(index) {
        this.currentIndex = index;
        this.lightbox.style.display = 'block';
        document.body.style.overflow = 'hidden';
        
        this.goToImage(index);
        
        requestAnimationFrame(() => {
            this.lightbox.classList.add('active');
            // Imposta zoom iniziale diverso per mobile e desktop
            setTimeout(() => {
                const container = this.getCurrentContainer();
                if (container) {
                    const img = container.querySelector('.lightbox-image');
                    const state = container.zoomState;
                    
                    // Controlla se siamo su mobile
                    const isMobile = window.innerWidth <= 768;
                    
                    if (isMobile) {
                        // Su mobile, parti con zoom al 100%
                        state.scale = 1;
                        state.translateX = 0;
                        state.translateY = 0;
                    } else {
                        // Su desktop mantieni lo zoom al 100%
                        state.scale = 1;
                        state.translateX = 0;
                        state.translateY = 0;
                    }
                    
                    this.applyZoom(img, state);
                    this.updateZoomLevel(state.scale);
                }
            }, 150);
        });
    }

    close() {
        const images = this.lightbox.querySelectorAll('.lightbox-image');
        images.forEach(img => {
            img.style.transform = 'scale(1) translate(0, 0)';
        });
        
        this.lightbox.classList.remove('active');
        document.body.style.overflow = '';
        
        setTimeout(() => {
            this.lightbox.style.display = 'none';
        }, 300);
    }

    goToImage(index) {
        const scrollContainer = this.lightbox.querySelector('.lightbox-images-scroll');
        const itemWidth = scrollContainer.offsetWidth;
        
        // Salva lo zoom corrente prima di cambiare immagine
        const prevContainer = this.getCurrentContainer();
        let currentScale = 1;
        if (prevContainer && prevContainer.zoomState) {
            currentScale = prevContainer.zoomState.scale;
        }
        
        scrollContainer.scrollTo({
            left: itemWidth * index,
            behavior: 'smooth'
        });
        this.currentIndex = index;
        this.updateActiveStates();
        
        // Applica lo stesso zoom alla nuova immagine
        setTimeout(() => {
            const newContainer = this.getCurrentContainer();
            if (newContainer) {
                const img = newContainer.querySelector('.lightbox-image');
                const state = newContainer.zoomState;
                if (state) {
                    state.scale = currentScale;
                    state.translateX = 0;
                    state.translateY = 0;
                    this.applyZoom(img, state);
                    this.updateZoomLevel(state.scale);
                }
            }
        }, 400);
    }

    updateActiveStates() {
        const currentIndexElement = this.lightbox.querySelector('.current-index');
        currentIndexElement.textContent = this.currentIndex + 1;
        
        const thumbnails = this.lightbox.querySelectorAll('.lightbox-thumbnail');
        thumbnails.forEach((thumb, index) => {
            if (index === this.currentIndex) {
                thumb.classList.add('active');
            } else {
                thumb.classList.remove('active');
            }
        });
        
        if (this.images[this.currentIndex] && this.productHandle) {
            this.triggerVariantChange(this.images[this.currentIndex].mediaId);
        }
    }
    
    applyCustomColors() {
        const modal = this.lightbox.querySelector('.lightbox-modal');
        if (modal) {
            modal.style.backgroundColor = this.bgColor;
        }
        
        const closeBtn = this.lightbox.querySelector('.lightbox-close');
        if (closeBtn) {
            closeBtn.style.color = this.closeColor;
            closeBtn.style.borderColor = this.closeColor;
        }
    }
    
    triggerVariantChange() {
        if (window.McShopify && window.McShopify.customEvent) {
            const form = document.querySelector('form[action*="/cart/add"]');
            if (form) {
                const variantInputs = form.querySelectorAll('input[name="id"]');
                variantInputs.forEach(() => {
                });
            }
        }
    }
    
    handleVariantChange(e) {
        if (e.detail && e.detail.mediaId) {
            const newIndex = this.images.findIndex(img => img.mediaId === e.detail.mediaId);
            if (newIndex !== -1 && newIndex !== this.currentIndex) {
                this.goToImage(newIndex);
            }
        }
    }

    setupZoomControls() {
        const zoomIn = this.lightbox.querySelector('.zoom-in');
        const zoomOut = this.lightbox.querySelector('.zoom-out');
        const zoomReset = this.lightbox.querySelector('.zoom-reset');

        zoomIn.addEventListener('click', () => this.zoomStepFixed(0.25));
        zoomOut.addEventListener('click', () => this.zoomStepFixed(-0.25));
        zoomReset.addEventListener('click', () => this.resetZoom());
    }
    
    getCurrentContainer() {
        const containers = this.lightbox.querySelectorAll('.lightbox-image-zoom-container');
        return containers[this.currentIndex];
    }
    
    applyZoom(img, state) {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            // Su mobile, usa il transform considerando il centering
            const centerX = -50 + (state.translateX * 100 / window.innerWidth);
            const centerY = -50 + (state.translateY * 100 / window.innerHeight);
            img.style.transform = `translate(${centerX}%, ${centerY}%) scale(${state.scale})`;
        } else {
            // Su desktop - usa sempre transform-origin center per coerenza
            img.style.transformOrigin = 'center center';
            img.style.left = '50%';
            img.style.top = '50%';
            img.style.transform = `translate(calc(-50% + ${state.translateX}px), calc(-50% + ${state.translateY}px)) scale(${state.scale})`;
        }
        
        img.style.cursor = 'grab';
        img.style.transition = 'transform 0.3s ease';
        
        // Aggiungi classe per lo stato di drag
        if (state.panning) {
            img.classList.add('dragging');
        } else {
            img.classList.remove('dragging');
        }
    }
    
    updateZoomLevel(scale) {
        const zoomLevelElement = this.lightbox.querySelector('.zoom-level');
        if (zoomLevelElement) {
            zoomLevelElement.textContent = `${Math.round(scale * 100)}%`;
        }
    }
    
    zoomStepFixed(step) {
        const container = this.getCurrentContainer();
        if (!container) return;

        const img = container.querySelector('.lightbox-image');
        const state = container.zoomState;

        state.scale = Math.min(Math.max(0.5, state.scale + step), 5);

        // Con il sistema di coordinate centrato, translateX/Y = 0 mantiene l'immagine centrata
        // Non serve ricalcolare quando si passa da ≤100% a >100%
        if (state.scale <= 1) {
            // Sotto o al 100%, centra l'immagine
            state.translateX = 0;
            state.translateY = 0;
        }

        this.applyZoom(img, state);
        this.updateZoomLevel(state.scale);
    }

    zoomStep(factor) {
        const container = this.getCurrentContainer();
        if (!container) return;

        const img = container.querySelector('.lightbox-image');
        const state = container.zoomState;

        state.scale = Math.min(Math.max(0.5, state.scale * factor), 5);

        // Sotto o al 100%, centra l'immagine
        if (state.scale <= 1) {
            state.translateX = 0;
            state.translateY = 0;
        }

        this.applyZoom(img, state);
        this.updateZoomLevel(state.scale);
    }
    
    resetZoom() {
        const container = this.getCurrentContainer();
        if (!container) return;
        
        const img = container.querySelector('.lightbox-image');
        const state = container.zoomState;
        
        state.scale = 1;
        state.translateX = 0;
        state.translateY = 0;
        
        this.applyZoom(img, state);
        this.updateZoomLevel(state.scale);
    }
    
    handleKeyboard(e) {
        if (this.lightbox.style.display === 'none') return;

        switch(e.key) {
            case 'Escape':
                this.close();
                break;
            case 'ArrowLeft':
                this.goToImage((this.currentIndex - 1 + this.images.length) % this.images.length);
                break;
            case 'ArrowRight':
                this.goToImage((this.currentIndex + 1) % this.images.length);
                break;
            case '+':
            case '=':
                this.zoomStep(1.5);
                break;
            case '-':
                this.zoomStep(0.67);
                break;
            case '0':
                this.resetZoom();
                break;
        }
    }
    
    setupCustomCursor() {
        // Crea l'elemento cursore personalizzato
        const customCursor = document.createElement('div');
        customCursor.className = 'lightbox-custom-cursor';
        customCursor.innerHTML = `
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="10" y1="2" x2="10" y2="18" stroke="#808080" stroke-width="1"/>
                <line x1="2" y1="10" x2="18" y2="10" stroke="#808080" stroke-width="1"/>
            </svg>
        `;
        customCursor.style.cssText = `
            position: fixed;
            width: 40px;
            height: 40px;
            background: #fff;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px;
            pointer-events: none;
            z-index: 9999;
            transform: translate(-50%, -50%);
            box-sizing: border-box;
        `;
        document.body.appendChild(customCursor);
        
        // Gestisci il movimento del cursore sui trigger
        const triggers = document.querySelectorAll('.lightbox-trigger');
        triggers.forEach(trigger => {
            trigger.addEventListener('mouseenter', () => {
                customCursor.style.display = 'flex';
            });
            
            trigger.addEventListener('mouseleave', () => {
                customCursor.style.display = 'none';
            });
            
            trigger.addEventListener('mousemove', (e) => {
                customCursor.style.left = e.clientX + 'px';
                customCursor.style.top = e.clientY + 'px';
            });
        });
    }
}

function initProductLightbox() {
    if (window.productLightbox) {
        return;
    }
    window.productLightbox = new ProductLightbox();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductLightbox);
} else {
    setTimeout(initProductLightbox, 100);
}

window.ProductLightbox = ProductLightbox;
window.initProductLightbox = initProductLightbox;